import { useEffect, useRef } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import "lenis/dist/lenis.css";
import { Nav } from "./components/Nav";
import { Footer } from "./components/Footer";
import Home from "./pages/Home";
import Venture from "./pages/Venture";

const SmoothScroll = () => {
  const lenis = useRef(null);
  const { pathname, hash } = useLocation();

  useEffect(() => {
    const l = new Lenis({ lerp: 0.09, anchors: true });
    lenis.current = l;
    let id;
    const raf = (t) => {
      l.raf(t);
      id = requestAnimationFrame(raf);
    };
    id = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(id);
      l.destroy();
    };
  }, []);

  useEffect(() => {
    if (!hash) lenis.current?.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
};

function App() {
  return (
    <BrowserRouter>
      <SmoothScroll />
      <Nav />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/ventures/:slug" element={<Venture />} />
        <Route path="*" element={<Home />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
